<template>
  <div style="width: 100%;height: 100%">
    <el-form :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="95px" class="demo-ruleForm">
      <el-row>
        <el-col :span="24">
          <el-form-item label="生成数量" prop="name">
            <el-input v-model="addEditForm.count" placeholder="生成数量"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin: 20px 30px 0">
      <el-row style="text-align: center">
        <el-col :span="12"><el-button type="danger" size="medium" @click="closeOpen()">取消</el-button></el-col>
        <el-col :span="12"><el-button type="success" size="medium" @click="submitAdd('addEditForm')">确定</el-button></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {getAuthCodeGenerate} from '../../api/authCode'

export default {
  name: 'addAuthCode',
  model: {
    prop: 'generateAuthCodeShow',
    event: 'change'
  },
  props: {
    bookObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      addEditForm: {
        count: ''
      },
      addEditRules: {
        count: [
          { required: true, message: '请输入生成数量', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
  },
  methods: {
    closeOpen () {
      this.$emit('change', false)
    },
    submitAdd (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sendAddAuthCode()
        } else {
          return false
        }
      })
    },
    sendAddAuthCode () {
      let body = {
        bookId: this.bookObj.row.id,
        count: this.addEditForm.count
      }
      getAuthCodeGenerate(body).then(res => {
        this.$message({
          message: '成功生成激活码',
          type: 'success'
        })
        this.$emit('getFatherAuthCode')
        this.$emit('change', false)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/materialManagement/addAuthCode.vue